import { string } from 'yup'
import Toc from './table-of-contents'
import Button from 'react-bootstrap/Button'
import Image from 'react-bootstrap/Image'
import { SearchTitle } from './item'
import styles from './item.module.css'
import Link from 'next/link'
import { timeSince } from '@/lib/time'
import EmailIcon from '@/svgs/mail-open-line.svg'
import Share, { CopyLinkDropdownItem } from './share'
import Badges from './badge'
import { MEDIA_URL } from '@/lib/constants'
import { Badge } from 'react-bootstrap'
import SubPopover from './sub-popover'
import { piconerosToMXmr } from '@/lib/format'
import { ensureProtocol } from '@/lib/url'
import { PayInInfo, InfoDropdownItem } from './item-info'
import PendingFeeBadge from './pending-fee-badge'
import PayPostingFeeButton from './pay-posting-fee-button'
import Boost from './boost-button'
import ActionDropdown from './action-dropdown'
import DontLikeThisDropdownItem from './dont-link-this'
import BookmarkDropdownItem from './bookmark'
import SubscribeDropdownItem from './subscribe'
import MuteDropdownItem from './mute'
import { useMe } from './me'

function CompanyImage ({ item }) {
  return (
    <Link href={`/items/${item.id}`}>
      <Image
        src={item.uploadId ? `${MEDIA_URL}/${item.uploadId}` : '/jobs-default.png'} width='42' height='42' className={styles.companyImage}
      />
    </Link>
  )
}

export default function ItemJob ({ item, toc, rank, children, ...props }) {
  const { me } = useMe()
  const isEmail = !!item.url && string().email().isValidSync(item.url)
  const hasApplyUrl = !!item.url
  const applyHref = isEmail
    ? `mailto:${item.url}?subject=${encodeURIComponent(item.title)} via Stasher News`
    : ensureProtocol(item.url || undefined)

  return (
    <>
      {rank
        ? (
          <div className={`${styles.rank} pb-2 align-self-center`}>
            {rank}
          </div>)
        : <div />}
      <div className={styles.item}>
        {item.mine
          ? (
            <div className={styles.jobBoostGroup}>
              <Boost item={item} />
              <CompanyImage item={item} />
            </div>)
          : <CompanyImage item={item} />}
        <div className={`${styles.hunk} align-self-center mb-0`}>
          <div className={`${styles.main} flex-wrap d-inline`}>
            <Link href={`/items/${item.id}`} className={`${styles.title} text-reset me-2`}>
              {item.searchTitle
                ? <SearchTitle title={item.searchTitle} />
                : (
                  <>{item.title}</>)}
            </Link>
          </div>
          <div className={styles.other}>
            <span>
              {piconerosToMXmr(BigInt(Number(item.piconeros) + Number(item.boost) + Number(item.cost) * 1000))}
            </span>
            <span> \ </span>
            {item.company &&
              <>
                {item.company}
              </>}
            {(item.location || item.remote) &&
              <>
                <span> \ </span>
                {`${item.location || ''}${item.location && item.remote ? ' or ' : ''}${item.remote ? 'Remote' : ''}`}
              </>}
            <wbr />
            <span> \ </span>
            <span>
              <Link href={`/${item.user.name}`} className='d-inline-flex align-items-center'>
                @{item.user.name}<Badges badgeClassName='fill-grey' height={12} width={12} user={item.user} />
              </Link>
              <span> </span>
              <Link href={`/items/${item.id}`} title={item.createdAt} className='text-reset' suppressHydrationWarning>
                {timeSince(new Date(item.createdAt))}
              </Link>
            </span>
            {item.subNames?.map(subName => (
              <SubPopover key={subName} sub={subName}>
                <Link href={`/~${subName}`}>
                  {' '}<Badge className={styles.newComment} bg={null}>{subName}</Badge>
                </Link>
              </SubPopover>
            ))}
            <PendingFeeBadge item={item} />
            <PayPostingFeeButton item={item} />
            {item.status === 'STOPPED' &&
              <>{' '}<Badge bg='info' className={styles.badge}>stopped</Badge></>}
            {item.mine && !item.deletedAt &&
              (
                <>
                  <wbr />
                  <span> \ </span>
                  <Link href={`/items/${item.id}/edit`} className='text-reset fw-bold'>
                    edit
                  </Link>
                  <PayInInfo item={item} {...props} />
                </>)}
            <ActionDropdown>
              <CopyLinkDropdownItem item={item} />
              <InfoDropdownItem item={item} />
              {me && <BookmarkDropdownItem item={item} />}
              {me && <SubscribeDropdownItem item={item} />}
              {me && !item.mine &&
                <DontLikeThisDropdownItem item={item} />}
              {me && !item.mine &&
                <>
                  <hr className='dropdown-divider' />
                  <MuteDropdownItem user={item.user} />
                </>}
            </ActionDropdown>
          </div>
        </div>
        {toc &&
          <>
            <Share title={item?.title} path={`/items/${item?.id}`} />
            <Toc text={item.text} />
          </>}
      </div>
      {children && (
        <div className={styles.children} style={{ marginLeft: 'calc(42px + .8rem)' }}>
          <div className='mb-3 d-flex'>
            <Button
              target={hasApplyUrl ? '_blank' : undefined}
              href={applyHref}
              disabled={!hasApplyUrl}
            >
              apply {isEmail && <EmailIcon className='ms-1' />}
            </Button>
            {isEmail && <div className='ms-3 align-self-center text-muted fw-bold'>{item.url}</div>}
          </div>
          {children}
        </div>
      )}
    </>
  )
}
